import {Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import RestHelper from "../../../Helper/RestHelper";
import {TokenStorageService} from "../../../services/token-storage.service";
import {User} from "../../../Interfaces/user.interface";
import {RestResponse} from "../../../Interfaces/RestResponse.interface";
import {Router} from "@angular/router";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent {

  public loginForm: FormGroup
  public invalidcredentials: boolean = false

  constructor(private formBuilder: FormBuilder, private httpClient: HttpClient, private tokenStorage: TokenStorageService, private router: Router) {
    this.loginForm = this.formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
      password: ["", [Validators.required]]
    })
  }

  public login() {
    if (!this.loginForm.valid) {
      this.loginForm.markAllAsTouched();
      console.log("Form Invalid")
      return;
    }

    const body = new FormData();
    body.append("password", this.loginForm.value.password)
    body.append("email", this.loginForm.value.email)

    this.httpClient.post<RestResponse<User>>(RestHelper.API_BASE_URL + "auth/login", body).subscribe({
      next: (value) => {
        this.invalidcredentials = false
        console.log(value.data)
        this.tokenStorage.setToken("access_token", value.data.access_token)
        this.tokenStorage.setToken("refresh_token", value.data.refresh_token)
        this.tokenStorage.setToken("user", JSON.stringify(value.data))
        this.loginForm.reset()
        this.router.navigate(['/startseite']).then(redirected => {
          if (!redirected) {
            console.error("Fehler beim Redirecten nach Login")
          }
        })
      },
      error: (err) => {
        this.loginForm.reset();
        this.invalidcredentials = true
        console.error(err)
      }
    })
  }

  public getFormControls() {
    return this.loginForm.controls;
  }
}
